

<div class="overlay"></div>
<div class="confirm-box">
  <div class="modal-body">
    {{ message }}
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-cancel" (click)="decline()">{{ btnCancelText }}</button>
    <button type="button" class="btn btn-ok" (click)="accept()">{{ btnOkText }}</button>
  </div>
</div>
